import { devtools } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import type { BartStoreState } from "@/ts/types";

export const initialState: BartStoreState = {
	siteId: "",
	scriptURL:
		"https://www.reachgeneric.co.uk/bad-ads-reporting-tool/js/AdVerification/verify-2.0.2.min.js",
};

export const bartStore = createStore<BartStoreState>()(
	devtools(
		() => ({
			...initialState,
		}),
		{
			name: "Hydra-BARTStore",
		},
	),
);
